import { z } from "zod"

export const projectFormSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  description: z.string().max(2000).optional(),
  mode: z.enum(["standard", "queued"]),
  workflow: z.enum(["radiology", "pathology"]),
  status: z.enum(["draft", "active", "paused", "completed", "archived"]),
  review_enabled: z.boolean(),
  multiplayer_cursors: z.boolean(),
  readers_per_case: z.number().int().min(1).max(5),
  sort_metric_key: z.string().optional(),
  sort_metric_type: z.enum(["integer", "float"]).optional(),
  sort_metric_direction: z.enum(["asc", "desc"]).optional(),
  due_date: z.string().optional()
})

export type ProjectFormData = z.infer<typeof projectFormSchema>
